<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-question-bank"
            @hidden="resetModal">
            <div class="container modal-create-question-bank__body">
                <div class="action"><img class="btn-close custom-cursor btn-float-right" src="@/assets/img/x.png"
                        @click="handleHideModal" /></div>
                <div class="header-modal margin-top-10">
                    <h3>Ngân hàng câu hỏi</h3>
                </div>
                <div class="row margin-top-10">
                    <div class="col-md-4">
                        <div class="item item__key input-custom-icon">
                            <input v-model.lazy="paramQueryData.keyword" v-debounce="1000" type="text"
                                placeholder="Tìm kiếm theo câu hỏi"
                                class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width" />
                            <i class="icon-search font-size-16 primary-color"></i>
                        </div>
                        <div class="row margin-top-10">
                            <div class="col-md-6">
                                <b-form-select @change="handleChangeClassId" v-model="paramQueryData.classId"
                                    :options="listDataClass">
                                </b-form-select>
                            </div>
                            <div class="col-md-6">
                                <b-form-select @change="handleChangeSubjectId" v-model="paramQueryData.subjectId"
                                    :options="listDataSubject">
                                </b-form-select>
                            </div>
                        </div>
                        <div class="custom-line">
                            <div class="line1"></div>
                            <div class="text-line">Nguồn câu hỏi</div>
                            <div class="line1"></div>
                        </div>
                        <div class="filter-source-question">
                            <div>Sách</div>
                            <div class="filter-book">
                                <b-form-checkbox-group v-model="paramQueryData.listBookTypeId" :options="listBookType"
                                    name="flavour-2a" stacked></b-form-checkbox-group>
                               
                            </div>
                            <div>Luyện tập khác</div>
                            <div class="filter-book">
                                <b-form-checkbox v-model="paramQueryData.chapterId" 
                                    name="flavour-2a" >Tự kiểm tra đánh giá</b-form-checkbox>
                            </div>
                            
                        </div>
                        <div class="custom-line">
                            <div class="line-all"></div>
                            
                        </div>
                        <div class="row margin-top-10">
                            <div class="col-md-6">
                                <b-form-select v-model="paramQueryData.type"
                                    :options="question_format">
                                </b-form-select>
                            </div>
                            <div class="col-md-6">
                                <b-form-select  v-model="paramQueryData.level"
                                    :options="levels">
                                </b-form-select>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div class="col-md-8">
                        <div class="display-flex justify-content-space-between">
                            <div class="count-result">Tổng: {{ totalRecords }} kết quả</div>
                            <div class="loadding">{{ statusSearch == 1 ? 'Đang tìm kiếm câu hỏi...' : '' }}</div>
                            <div class="count-choose">
                                Đã chọn: {{ this.listQuestionAdd.length }}
                            </div>
                        </div>
                        <div class="wrap-right" ref="scrollContainer" @scroll="handleScrollQuestion">

                            <div class="list-question">
                                <div class="question-item display-flex"
                                    v-for="(dataSource, index) of listDataQuestionBank" :key="index">
                                    <div class="question col-md-11">
                                        <PreviewQuestion :id="`question_${index}`" :dataSource="dataSource"
                                            :location="index" :questions="listDataQuestionBank"
                                            :isDontShowResultSaved="false" />

                                    </div>
                                    <div class="col-md-1">
                                        <b-form-checkbox @change="handSelectQuestion($event, dataSource)">
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form_action display-flex justity-content-end">
                    <button type="button"
                        class="btn btn-cancel border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        :disabled="isLoading" @click="handleHideModal">
                        Hủy bỏ
                    </button>
                    <button type="button"
                        class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        @click="handleShowConfimQuestionBank" :disabled="isLoading">
                        Thêm mới
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { getAllTypeFilter, getAllClassFilter } from "./../../../_api/";
import { getListQuestionBank } from "./../../../_api/LessonClassSchoolServices";
import fillBlankOrSelect from "./../../../../question/preview-question/answers/fill-blank-select/fillBlankOrSelect.vue";
import debounce from "@/directives/debounce";
import EdittorCKAnswer from "@/components/EdittorCKAnswer.vue";
import MultipleChoice from "./../../../../question/preview-question/answers/multiple-choice/MultipleChoice.vue";
import MathCol from "./../../../../question/preview-question/answers/math-col/MathCol.vue";
import FillInputImg from "./../../../../question/preview-question/answers/fill-input-img/FillInputImg.vue";
import TrueFalseAnswer from "./../../../../question/preview-question/answers/true-false/TrueFalseAnswer.vue";
import MultipleAnswer from "./../../../../question/preview-question/answers/multiple-answers/MultipleAnswer.vue";
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
import { replaceAllContent } from "./../../../../question/preview-question/_store/helperQuestionContent";
export default {
    name: "ModalCreateQuestionBank",
    directives: { debounce },
    components: {
        TrueFalseAnswer,
        fillBlankOrSelect,
        EdittorCKAnswer,
        MultipleChoice,
        MathCol,
        FillInputImg,
        MultipleAnswer,
        PreviewQuestion
    },
    watch: {
        // 'paramQueryData.classId': 'handleChangeClassId',
        // 'paramQueryData.subjectId': 'handleChangeSubjectId',
        "paramQueryData.keyword": "handleSearchData",
        "paramQueryData.listBookTypeId": "handleChangeBookTypeId",
        "paramQueryData.type": "handleSearchData",
        "paramQueryData.level": "handleSearchData",
        "paramQueryData.chapterId": "handleSearchData",
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    data() {
        return {
            TYPE_RADIO: "radio",
            TYPE_CHECKBOX: "checkbox",
            TYPE_TRUE_FALSE_NO: "answer_t_f_no",
            TYPE_MATH_COL: "math_col",
            TYPE_FILL_BLANK: "fill_blank",
            TYPE_FILL_SENTENCE: "fill_sentence",
            TYPE_SELECT: "select",
            TYPE_DOWN_ANSWER: "down_answer",
            TYPE_CIRCLE_ANSWER: "circle_answer",
            TYPE_X_MARK: "x_mark_answer",
            TYPE_DRAW_SHAPE_ANSWER: "draw_shape_answer",
            TYPE_GROUP: "group",
            TYPE_FILL_INPUT_IMG: "fill_input_img",

            confirmActive: {},
            submitted: false,
            isLoading: false,
            statusSearch: 0,
            listDataSubject: [{ value: 0, text: "Tất cả - môn" }],
            listDataClass: [{ value: 0, text: "Tất cả - lớp" }],
            listDataQuestionBank: [],
            totalRecords: 0,
            totalPage: 0,
            paramQueryData: {
                type:'',
                level:'',
                chapterId:true,
                keyword: "",
                pageIndex: 1,
                pageSize: 5,
                subjectId: 0,
                classId: 0,
                listBookTypeId: [3,4,5,6],
            },
            listBookType: [
                { text: "Kết nối tri thức với cuộc sống", value: 3 },
                { text: "Chân trời sáng tạo", value: 4 },
                { text: "Cùng học để phát triển năng lực", value: 5 },
                { text: "Vì sự bình đẳng và dân chủ trong giáo dục", value: 6 },
            ],
            listQuestionAdd: [],
            question_format: [],
            levels: [],
        };
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.GetAllClass();
        this.handleShowModal();
        this.statusSearch = 1
        this.getListQuestionBank();
        this.question_format=[
                {value: '', text: 'Định dạng - Tất cả'},
                {value: this.TYPE_RADIO, text: 'Chỉ có 1 câu trả lời đúng'},
                {value: this.TYPE_CHECKBOX, text: 'Có nhiều câu trả lời đúng'},
                {value: this.TYPE_X_MARK, text: 'Đánh dấu X vào câu tương ứng'},
                {value: this.TYPE_CIRCLE_ANSWER, text: 'Khoanh tròn vào đáp án đúng'},
                {value: this.TYPE_TRUE_FALSE_NO, text: 'Điền từ đúng (Đ) - Sai (S) hoặc số thứ tự các câu'},
                {value: this.TYPE_FILL_INPUT_IMG, text: 'Điền câu trả lời vào ô trống'},
                {value: this.TYPE_FILL_BLANK, text: 'Câu điền từ vào chỗ trống (Đoạn văn và hoàn thành câu)'},
                {value: this.TYPE_SELECT, text: 'Câu trả lời trong select box (Đoạn văn và hoàn thành câu)'},
                {value: this.TYPE_MATH_COL, text: 'Nối câu tương ứng'},
                {value: this.TYPE_DOWN_ANSWER, text: 'Câu tự luận'}
            ]
        this.levels = [
            {
                value: '',
                text: 'Mức độ'
            },
            {
                value: 'easy',
                text: 'Dễ'
            },
            {
                value: 'medium',
                text: 'Trung bình'
            },
            {
                value: 'difficult',
                text: 'Khó'
            }
        ]
    },
    methods: {
        replaceAllContent,
        handSelectQuestion(isCheck, itemAdd) {
            if (isCheck) {
                this.listQuestionAdd.push(itemAdd);
            } else {
                for (let i = 0; i < this.listQuestionAdd.length; i++) {
                    const item = this.listQuestionAdd[i];
                    if (item.questionId == itemAdd.questionId) {
                        this.listQuestionAdd.splice(i, 1);
                        break;
                    }
                }
            }
        },
        handleShowConfimQuestionBank() {
            this.handleDone();
        },
        handleScrollQuestion(e) {
            const container = this.$refs.scrollContainer;
            const scrollHeight = container.scrollHeight;
            const scrollTop = container.scrollTop;
            const offsetHeight = container.offsetHeight;
            const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
            if (bottomOffset <= 0 && !this.isLoading) {
                // Load more items when the user reaches the bottom with some offset
                let pageIndexSearch = this.paramQueryData.pageIndex + 1;
                if (pageIndexSearch <= this.totalPage) {
                    this.paramQueryData.pageIndex++;
                    this.getListQuestionBank();
                }
            }
        },
        resetData() {
            this.paramQueryData.pageIndex = 1;
            (this.listDataQuestionBank = []),
                (this.totalRecords = 0),
                (this.totalPage = 0);
        },
        getListQuestionBank() {
            let self = this;
            getListQuestionBank(this.paramQueryData).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        self.listDataQuestionBank.push({ ...item });
                    }

                    self.totalRecords = res.data.paging.totalRecords;
                    self.totalPage = res.data.paging.totalPage;
                }
                self.statusSearch = 2
            });
        },
        handleChangeSubjectId(e) {
            //this.subjectId = e.target.value
            this.handleOnFilter();
        },
        handleChangeClassId(e) {
            this.getTypesFilter();
            //this.classId = e.target.value
            this.handleOnFilter();
        },
        handleSearchData() {
            this.handleOnFilter();
        },
        handleChangeBookTypeId() {
            this.handleOnFilter();
        },
        handleOnFilter() {
            this.statusSearch = 1
            this.resetData();
            this.getListQuestionBank();
        },
        getTypesFilter() {
            let self = this;
            self.listDataSubject = [{ value: 0, text: "Tất cả - môn" }];
            this.subjectId = 0;
            getAllTypeFilter({ classId: this.paramQueryData.classId }).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({
                            value: item.subjectId,
                            text: item.name,
                        });
                    }
                }
            });
        },
        GetAllClass() {
            let self = this;
            getAllClassFilter({}).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name });
                    }
                }
            });
        },
        handleDone() {
            if (this.listQuestionAdd.length > 0) {
                this.handleHideModal();
                this.$emit("handleDone", this.listQuestionAdd);
            } else {
                this.$toast.error("Vui lòng chọn câu hỏi");
            }
        },
        resetModal() {
            console.log("resetModal");
            this.submitted = false;
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs["modal-create-question-bank"].toggle("#toggle-btn");
        },
        handleHideModal() {
            //this.$refs['modal-create-question-bank'].hide()
            this.$emit("closeModal");
        },
        handleShowModal() {
            this.$refs["modal-create-question-bank"].show();
        },
    },
};
</script>
<style>
.question .input-hide-place {
    width: 40px;
}
</style>
<style lang="scss" scoped>
.loadding {
    color: green;
}

.modal-create-question-bank__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;

    // custom size modal
    max-width: 90%;
    top: 2%;
    left: 5%;
    right: 0;
    position: fixed;
    z-index: 100000;
    margin: 0px;

    .modal__actions {
        margin-top: 10px;

        .btn-delete {
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }

        .btn-cancel {
            margin-right: 10px;
            color: #dd352f;
            font-family: sans-serif;
        }
    }
}

.justity-content-end {
    justify-content: end
}

.wrap-right {
    padding: 5px;
    border-radius: 10px;
    border: 1px solid #eaeaea;
    max-height: calc(80vh - 20px);
    overflow: auto;
}

.question {
    overflow: auto;
    margin: 5px;
    border: 1px solid #a1b5f3;
    border-radius: 15px;
}

.margin-top-10 {
    margin-top: 10px;
}

.justify-content-space-between {
    justify-content: space-between;
}
.line-all{
    width: 100%;
    height: 2px;
    background: #e5e5e5;
}
.custom-line {
    width: 100%;
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .line1 {
        width: 35%;
        height: 2px;
        background: #e5e5e5;
    }

    .line2 {
        width: 35%;
        height: 2px;
        background: #e5e5e5;
    }

    .text-line {
        margin-top: -10px;
        padding-left: 10px;
        padding-right: 10px;
        color: #e5e5e5;
        width: 125px;
        font-size: 14px;
    }
}

.btn-float-right {
    float: right;
    width: 15px;
}
</style>
